import {
  SortableContext,
  horizontalListSortingStrategy,
} from "@dnd-kit/sortable";

import {
  BaseTableV3Body,
  MemoizedBaseTableV3Body,
} from "components/BaseTableV3/BaseTableV3Body";
import { BaseTableV3Header } from "components/BaseTableV3/BaseTableV3Header";
import { BaseTableV3SkeletonBody } from "components/BaseTableV3/BaseTableV3SkeletonBody";
import { MessageSnack } from "components/BaseTableV3/MessageSnack";

function TableBody({ table, isLoading }) {
  if (isLoading) return <BaseTableV3SkeletonBody table={table} />;
  if (table.getState().columnSizingInfo.isResizingColumn) {
    return <MemoizedBaseTableV3Body table={table} />;
  }
  return <BaseTableV3Body table={table} />;
}

export function ResponsiveTable({
  table,
  columnOrder,
  isFetched,
  isError,
  queryResult,
  columnSizeVars,
  handleResizeColumnQuery,
}) {
  const hasData = queryResult?.data?.length > 0;
  // BaseTableV3 seeds every query key with empty initialData, so a new page,
  // sort, or filter starts unfetched and empty, exactly like the first load.
  const isLoading = !isFetched && !hasData && !isError;

  return (
    <div className="tw:relative tw:block tw:flex-1 tw:overflow-auto tw:bg-(--color-surface) tw:[scrollbar-gutter:stable]">
      {isFetched && !hasData && !isError ? (
        <MessageSnack
          message="No records found. Try adjusting your filters."
          messageType="warning"
        />
      ) : null}
      {isError ? (
        <MessageSnack
          message={"Error fetching data. Please try again."}
          messageType="error"
        />
      ) : null}
      <table
        style={columnSizeVars}
        className="tw:w-full tw:table-fixed tw:border-collapse tw:border-spacing-0"
      >
        <thead className="tw:sticky tw:top-0 tw:z-5">
          {table.getHeaderGroups().map(headerGroup => (
            <tr
              key={headerGroup.id}
              className="tw:border-b tw:border-(--color-border)"
            >
              <SortableContext
                items={columnOrder}
                strategy={horizontalListSortingStrategy}
              >
                {headerGroup.headers.map(header => (
                  <BaseTableV3Header
                    key={header.id}
                    header={header}
                    handleResizeColumnQuery={handleResizeColumnQuery}
                  />
                ))}
              </SortableContext>
            </tr>
          ))}
        </thead>

        <TableBody table={table} isLoading={isLoading} />
      </table>
    </div>
  );
}
